import { ChartTooltip } from '../../components/Widgets/ChartTooltip/ChartTooltip';
import { ChartTooltipInteraction } from '../../components/Widgets/ChartTooltip/ChartTooltipInteraction';
import { ChartTooltipItem } from '../../components/Widgets/ChartTooltip/ChartTooltipItem';
import { TooltipProps } from './tooltip/Tooltip';

export const RenderTooltip = <Datum,>({ tooltipData, isPinned, ...accessors }: TooltipProps<Datum>) => (
  <ChartTooltip
    minWidth={221}
    maxWidth={221}
    boxShadow={t => t.shadows[10]}
    interactionsMenuOpen={isPinned}
    titleSlot={
      <ChartTooltipItem
        dotColor={accessors.getColor(tooltipData)}
        title={accessors.labelFormatter?.(tooltipData, { where: 'tooltip' }) ?? accessors.getIdentifier(tooltipData)}
      />
    }
    interactions={
      <ChartTooltipInteraction
        primary={accessors.labelFormatter?.(tooltipData, { where: 'tooltip' }) ?? accessors.getIdentifier(tooltipData)}
      />
    }>
    <ChartTooltipItem title="metric" value={accessors.valueFormatter?.(tooltipData, { where: 'tooltip' })} />
  </ChartTooltip>
);
